import(/* webpackMode: "eager" */ "/vercel/path0/components/SolutionArticle.js")